import HackleCore from "../../HackleCore"
import { HackleEvent } from "../model/model"
import { PageEventTracker } from "../page/PageEventTracker"
import { UserManager } from "../user/UserManager"
import { Engagement } from "./Engagement"
import { EngagementListener } from "./EngagementListener"

export class EngagementEventTracker implements EngagementListener {
  private static readonly ENGAGEMENT_EVENT_KEY = "$engagement"
  private static readonly ENGAGEMENT_TIME_PROPERTY_KEY = "$engagement_time_ms"

  constructor(private readonly core: HackleCore, private readonly userManager: UserManager) {}

  onEngagement(engagement: Engagement, timestamp: number): void {
    const hackleEvent: HackleEvent = {
      key: EngagementEventTracker.ENGAGEMENT_EVENT_KEY,
      properties: {
        [PageEventTracker.PAGE_NAME_PROPERTY_KEY]: engagement.page.pageTitle,
        [EngagementEventTracker.ENGAGEMENT_TIME_PROPERTY_KEY]: engagement.durationMillis
      }
    }

    this.core.track(hackleEvent, this.userManager.resolve(), timestamp)
  }
}
